"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Toolbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../hooks");
var _DownloadButton = require("../DownloadButton");
var _Overview = require("../Overview");
var _PageNavigator = require("../PageNavigator");
var _Share = require("../Share");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
/**
 *  Top section of the catalogue.
 *  It contains Share, Download, PageNavigator and Overview components.
 */ const Toolbar = exports.Toolbar = /*#__PURE__*/ (0, _react.memo)(()=>{
    const { config: { downloadEnabled, sharingPageEnabled } } = (0, _hooks.useConfiguration)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        role: "toolbar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ActionsContainer, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Overview.Overview, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ActionsContainer, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PageNavigator.PageNavigator, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.ActionsContainer, {
                children: [
                    downloadEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DownloadButton.DownloadButton, {}) : null,
                    sharingPageEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Share.ShareButton, {}) : null
                ]
            })
        ]
    });
});
